"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ListWithOtherFields = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _fields = require("../../fields");

var _listWithOtherConfig = require("./listWithOtherConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var ListWithOtherDefinition = _flowRuntime["default"].tdz(function () {
  return _listWithOtherConfig.ListWithOtherDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("component", _flowRuntime["default"].ref(ListWithOtherDefinition)), _flowRuntime["default"].property("optionValue", _flowRuntime["default"].string()), _flowRuntime["default"].property("resetFields", _flowRuntime["default"]["function"](_flowRuntime["default"]["return"](_flowRuntime["default"]["void"]())))));

var isOther = function isOther(optionValue) {
  var otherValue = 'other';

  var hasOtherStringValue = function hasOtherStringValue() {
    if (typeof optionValue === 'string') {
      var lowerCaseOptionValue = optionValue.toLowerCase();
      return lowerCaseOptionValue === otherValue || lowerCaseOptionValue.includes(otherValue);
    }

    return false;
  };

  var hasOtherValueInArray = function hasOtherValueInArray() {
    if (Array.isArray(optionValue)) {
      var lowerCaseOptionValues = optionValue.map(function (option) {
        return option.toLowerCase();
      });
      return lowerCaseOptionValues.includes(otherValue);
    }

    return false;
  };

  return hasOtherStringValue() || hasOtherValueInArray();
};

var ListWithOtherFields = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ListWithOtherFields, _React$Component);

  var _super = (0, _createSuper2["default"])(ListWithOtherFields);

  function ListWithOtherFields() {
    var _this;

    (0, _classCallCheck2["default"])(this, ListWithOtherFields);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleChange = function () {
      var resetFields = _this.props.resetFields;
      resetFields();
    };

    return _this;
  }

  (0, _createClass2["default"])(ListWithOtherFields, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          component = _this$props.component,
          optionValue = _this$props.optionValue;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.renderList(component), optionValue && isOther(optionValue) && /*#__PURE__*/_react["default"].createElement(_fields.Textfield, {
        textfield: _listWithOtherConfig.other,
        inheritedFieldValidation: component.inheritedFieldValidation
      }));
    } // Loosely typing component as switching between component types

  }, {
    key: "renderList",
    value: function renderList(component) {
      switch (component.options && component.options.listType) {
        case 'radio':
          return /*#__PURE__*/_react["default"].createElement(_fields.Radio, {
            id: _listWithOtherConfig.select.key,
            radio: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, component), {}, {
              key: _listWithOtherConfig.select.key,
              type: 'radio'
            }),
            onChange: this.handleChange,
            inheritedFieldValidation: component.inheritedFieldValidation
          });

        case 'checkbox':
          return /*#__PURE__*/_react["default"].createElement(_fields.CheckboxGroup, {
            id: _listWithOtherConfig.select.key,
            checkboxGroup: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, component), {}, {
              key: _listWithOtherConfig.select.key,
              type: 'checkbox'
            }),
            onChange: this.handleChange,
            inheritedFieldValidation: component.inheritedFieldValidation
          });

        default:
          return /*#__PURE__*/_react["default"].createElement(_fields.Select, {
            id: _listWithOtherConfig.select.key,
            select: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, component), {}, {
              key: _listWithOtherConfig.select.key,
              type: _listWithOtherConfig.select.type
            }),
            onChange: this.handleChange,
            inheritedFieldValidation: component.inheritedFieldValidation
          });
      }
    }
  }]);
  return ListWithOtherFields;
}(_react["default"].Component);

exports.ListWithOtherFields = ListWithOtherFields;
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var componentKey = ownProps.componentKey;
  return {
    optionValue: selector(state, "".concat(componentKey, ".option"))
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var componentKey = ownProps.componentKey;
  var optionPath = "".concat(componentKey, ".option");
  var otherPath = "".concat(componentKey, ".other");
  var fields = [optionPath, otherPath];
  return {
    resetFields: function resetFields() {
      Promise.all([dispatch((0, _reduxForm.change)('form', optionPath, '')), dispatch((0, _reduxForm.change)('form', otherPath, '')), dispatch(_reduxForm.untouch.apply(void 0, ['form'].concat(fields)))]);
    }
  };
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ListWithOtherFields);

exports["default"] = _default;